module.exports = __webpack_public_path__ + "static/media/logo_nav.fcb4cbb8.png";